class Gallery {
  constructor() {
    this.setupNavHover();

    this.container = document.querySelector('.projet-gallery');
    if (!this.container) return;

    this.mainImg = this.container.querySelector('.gallery-image img');
    this.thumbs = this.container.querySelectorAll('.gallery-thumb');
    this.thumbsStrip = this.container.querySelector('.gallery-thumbs');
    this.prevBtn = this.container.querySelector('.gallery-prev');
    this.nextBtn = this.container.querySelector('.gallery-next');
    this.currentIndex = 0;

    this.preloadImages();
    this.setupSwipe();
    this.setupThumbOrientations();

    this.thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        this.goTo(parseInt(thumb.dataset.index));
      });
    });

    this.prevBtn.addEventListener('click', () => {
      this.goTo(this.currentIndex - 1);
    });

    this.nextBtn.addEventListener('click', () => {
      this.goTo(this.currentIndex + 1);
    });
  }

  setupNavHover() {
    if (!window.matchMedia('(hover: hover)').matches) return;

    const wraps = document.querySelectorAll('.projet-nav-wrap');
    if (!wraps.length) return;

    wraps.forEach((wrap) => {
      const isPrev = !!wrap.querySelector('.projet-nav-arrow--prev');
      const svg = wrap.querySelector('.projet-nav-arrow svg');
      const cardLink = wrap.querySelector('.projet-nav-card-link');

      if (!svg || !cardLink) return;

      wrap.addEventListener('mouseenter', () => {
        const svgRect = svg.getBoundingClientRect();
        const cardRect = cardLink.getBoundingClientRect();

        // Pour prev : le SVG (gauche) doit arriver à 20px du bord gauche de la card
        // card.left après translate = svg.left - 20
        // translateX = -(cardRect.left - svg.left + 20)
        //
        // Pour next : le SVG (droite) doit arriver à 20px du bord droit de la card
        // card.right après translate = svg.right + 20
        // translateX = svg.right + 20 - cardRect.right
        const translateX = isPrev
          ? -(cardRect.left - svgRect.left + 20)
          : svgRect.right + 20 - cardRect.right;

        cardLink.style.transform = `translateX(${translateX}px)`;
      });

      wrap.addEventListener('mouseleave', () => {
        cardLink.style.transform = 'translateX(0)';
      });
    });
  }

  setupSwipe() {
    const imageEl = this.container.querySelector('.gallery-image');
    if (!imageEl) return;

    let touchStartX = 0;

    imageEl.addEventListener('touchstart', (e) => {
      touchStartX = e.touches[0].clientX;
    }, { passive: true });

    imageEl.addEventListener('touchend', (e) => {
      const delta = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(delta) < 50) return;
      this.goTo(delta > 0 ? this.currentIndex + 1 : this.currentIndex - 1);
    }, { passive: true });
  }

  setupThumbOrientations() {
    this.thumbs.forEach((thumb) => {
      const w = parseInt(thumb.dataset.width);
      const h = parseInt(thumb.dataset.height);
      if (!w || !h) return;
      thumb.dataset.orientation = w >= h ? 'landscape' : 'portrait';
    });
  }

  preloadImages() {
    this.thumbs.forEach((thumb) => {
      const img = new Image();
      img.src = thumb.dataset.src;
    });
  }

  goTo(index) {
    if (index < 0) index = this.thumbs.length - 1;
    if (index >= this.thumbs.length) index = 0;
    if (index === this.currentIndex) return;

    this.currentIndex = index;
    const thumb = this.thumbs[index];

    this.mainImg.src = thumb.dataset.src;
    this.mainImg.alt = thumb.dataset.alt;

    this.thumbs.forEach(t => t.classList.remove('active'));
    thumb.classList.add('active');

    if (this.thumbsStrip) {
      const scrollTarget = thumb.offsetLeft - (this.thumbsStrip.clientWidth / 2) + (thumb.offsetWidth / 2);
      this.thumbsStrip.scrollTo({ left: scrollTarget, behavior: 'smooth' });
    }
  }
}

export { Gallery }
